var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5152 3.055L15 6.513L11.5152 9.945V7.644H6.30051V5.356H11.5152V3.055ZM9.41919 9.711L10.7576 11.102C9.44444 12.3673 8.02189 13 6.4899 13C4.6633 13 3.125 12.3782 1.875 11.1345C0.625 9.89083 0 8.33733 0 6.474C0 5.304 0.286195 4.22067 0.858586 3.224C1.43098 2.22733 2.20328 1.44083 3.1755 0.8645C4.14773 0.288167 5.20202 0 6.33838 0C7.88721 0 9.35606 0.641333 10.7449 1.924L9.41919 3.302C8.4596 2.40067 7.43687 1.95 6.35101 1.95C5.0968 1.95 4.0383 2.40067 3.1755 3.302C2.31271 4.20333 1.88131 5.304 1.88131 6.604C1.88131 7.81733 2.32534 8.86167 3.21338 9.737C4.10143 10.6123 5.1431 11.05 6.33838 11.05C7.44108 11.05 8.46801 10.6037 9.41919 9.711Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.8e92484e.svg";
export { ForwardRef as ReactComponent };